module.exports = __webpack_public_path__ + "img/gbt95-85-8.prt.36e4b7e9.jpg";